import React from 'react';
import { AppService } from '@aperza/util';
import style from './NavigationHeader.module.scss';
import { addUtmParam } from '../../addUtmParam';
import { useAperzaUserContext } from '../AperzaUserContext';
const serverHost = AppService.wwwServerHost();
const CatalogLocalNavigation = () => {
    const { serviceType } = useAperzaUserContext();
    return (React.createElement(React.Fragment, null,
        React.createElement("a", { href: addUtmParam(`${serverHost}/feature/top`, 'header', serviceType) }, "\u30AB\u30BF\u30ED\u30B0\u7279\u96C6"),
        React.createElement("a", { href: addUtmParam(`${serverHost}/trends/top/`, 'header', serviceType) }, "\u304A\u3059\u3059\u3081\u60C5\u5831"),
        React.createElement("a", { href: addUtmParam(`${serverHost}/catalog/category/`, 'header', serviceType) }, "\u30AB\u30BF\u30ED\u30B0\u5206\u985E"),
        React.createElement("a", { href: addUtmParam(`${serverHost}/company/top`, 'header', serviceType) }, "\u63B2\u8F09\u4F01\u696D\u4E00\u89A7"),
        React.createElement("a", { href: addUtmParam(`${serverHost}/company/new/`, 'header', serviceType) }, "\u65B0\u7740\u63B2\u8F09\u4F01\u696D"),
        React.createElement("span", { className: style.navbarDivider }),
        React.createElement("a", { href: addUtmParam(`https://www.aperza.com/corp/service/aperzacatalog_guide/`, 'header', serviceType), target: "_blank" }, "\u30AB\u30BF\u30ED\u30B0\u63B2\u8F09\u4F9D\u983C")));
};
export default CatalogLocalNavigation;
